import {
  DefaultMenuItem,
  GetContextMenuItemsParams,
  MenuItemDef,
} from 'ag-grid-community'
import { ApiTokenManagementRow } from '../ApiTokenManagementRow'
import { intl } from '../../../../i18n'
import {
  ContextMenuItemId,
  getMenuIconHtml,
} from '../../../containers/commons/AgGrid/lib/contextMenu'

type RevokeHandler = (row: ApiTokenManagementRow) => void

export const createGetContextMenuItems =
  (onRevoke: RevokeHandler) =>
  (
    params: GetContextMenuItemsParams<ApiTokenManagementRow>
  ): (DefaultMenuItem | MenuItemDef)[] => {
    const { data } = params.node ?? {}
    if (!data || data.revoked) {
      return []
    }

    return [
      {
        name: intl.formatMessage({
          id: 'apiTokenManagement.contextMenu.revoke',
        }),
        icon: getMenuIconHtml(ContextMenuItemId.REMOVE_ROW),
        action: () => onRevoke(data),
      },
    ]
  }
